/* eslint-disable camelcase */
import { placeSlugTypes, FILTERS } from 'views/motorcycle_rental/utils/constants';
import { SLUGS_TYPES } from 'utils/constants';

export const geoPath = (slugs) => {
  let url = '';
  slugs.forEach((slug) => {
    if (slug) url += `/${encodeURIComponent(slug)}`;
  });

  return url;
};
export const appendQuery = (url, query) => {
  let queryString = '';
  if (query) {
    queryString = '?';
    Object.entries(query).forEach(([key, value]) => {
      if (queryString !== '?') queryString += '&';
      queryString += `${key}=${value}`;
    });
    queryString = queryString === '?' ? '' : queryString;
  }
  return url + queryString;
};
export const moneyFormat = (moneyObject) => {
  switch (moneyObject.getPrecision()) {
    case 4:
      return moneyObject.hasCents()
        ? moneyObject.toFormat('$0,0.0000')
        : moneyObject.toFormat('$0,0');
    case 3:
      return moneyObject.hasCents()
        ? moneyObject.toFormat('$0,0.000')
        : moneyObject.toFormat('$0,0');
    default:
      return moneyObject.hasCents()
        ? moneyObject.toFormat('$0,0.00')
        : moneyObject.toFormat('$0,0');
  }
};

const getQuery = () => {
  const queries = {};
  window.location.search
    .slice(1)
    .split('&')
    .forEach((queryItem) => {
      const [key, value] = queryItem.split('=');
      queries[key] = value;
    });
  return queries;
};

export const initPageParams = (slugsData) => {
  if (!slugsData) return null;
  const { slugs } = slugsData;
  const query = getQuery();
  return {
    pickup_place_slug:
      slugs.find(({ slug_type }) => placeSlugTypes.includes(slug_type))?.slug || null,
    lat: query.lat || null,
    lng: query.lng || null,
    dropoff_location_id: query.dropoff_geography_id || null,
    vehicle_make_slug:
      slugs.find(({ slug_type }) => slug_type === SLUGS_TYPES.vehicle_make)?.slug || null,
    vehicle_model_slug:
      slugs.find(({ slug_type }) => slug_type === SLUGS_TYPES.vehicle_model)?.slug || null,
    vehicle_type_slug:
      query.vehicle_type_slug
      || slugs.find(({ slug_type }) => slug_type === SLUGS_TYPES.vehicle_type)?.slug
      || null,
    pickup_date: query.pickup_date || null,
    dropoff_date: query.dropoff_date || null,
    page: query.page || 1,
  };
};

export const getNewParam = (param) => {
  const pickupParams = param.new_place_slug
    ? {
      pickup_place_slug: param.new_place_slug,
    }
    : {};
  const vehicleMakeSlug = param.new_vehicle_make_slug
    ? { vehicle_make_slug: param.new_vehicle_make_slug }
    : {};
  const vehicleModelSlug = param.new_vehicle_model_slug
    ? { vehicle_model_slug: param.new_vehicle_model_slug }
    : {};
  const vehicleTypeSlug = param.new_vehicle_type_slug
    ? { vehicle_type_slug: param.new_vehicle_type_slug }
    : {};
  return {
    ...pickupParams,
    ...vehicleMakeSlug,
    ...vehicleModelSlug,
    ...vehicleTypeSlug,
  };
};

export const getCurrentParams = (rentalData) => {
  let pickupParams = {
    pickup_place_slug: rentalData?.selected_filters?.pickup_place?.slug,
  };
  if (rentalData?.selected_filters?.pickup_place?.id === null) {
    pickupParams = rentalData?.selected_filters?.pickup_place?.location;
  }
  return {
    ...pickupParams,
    dropoff_location_id: rentalData?.selected_filters?.dropoff_location?.id,
    vehicle_make_slug: rentalData?.selected_filters?.vehicle_make?.slug,
    vehicle_model_slug: rentalData?.selected_filters?.vehicle_model?.slug,
    vehicle_type_slug: rentalData?.selected_filters?.vehicle_type?.slug,
    pickup_date: rentalData?.selected_filters?.pickup_date,
    dropoff_date: rentalData?.selected_filters?.dropoff_date,
    page: rentalData?.pagination.current_page,
  };
};

const { VEHICLE_MODELS, VEHICLE_MAKES, VEHICLE_TYPES } = FILTERS;

const getObjectValue = (rentalData, filterType, selectedFilter) => rentalData?.filters[filterType].find(
  (filter) => filter.id === selectedFilter?.id,
)
  || selectedFilter
  || null;

export const getFiltersProps = (rentalData, handleFieldChange, translatedType) => ({
  type: {
    vehicleTypes: rentalData?.filters.vehicle_types,
    selectedType: getObjectValue(rentalData,
      VEHICLE_TYPES,
      rentalData?.selected_filters?.vehicle_type),

    onChange: (e, newValue) => handleFieldChange({
      vehicle_type_slug: newValue.slug,
      vehicle_make_slug: null,
      vehicle_model_slug: null,
      page: 1,
    }),
  },
  make: {
    vehicleMakes: rentalData?.filters.vehicle_makes,
    selectedMake: getObjectValue(rentalData,
      VEHICLE_MAKES,
      rentalData?.selected_filters?.vehicle_make),
    onChange: (e, newValue) => handleFieldChange({
      vehicle_type_slug: newValue?.slug ? null : translatedType,
      vehicle_make_slug: newValue?.slug,
      vehicle_model_slug: null,
      page: 1,
    }),
  },
  model: {
    vehicleModels: rentalData?.filters.vehicle_models,
    selectedModel: getObjectValue(rentalData,
      VEHICLE_MODELS,
      rentalData?.selected_filters?.vehicle_model),
    onChange: (e, newValue) => handleFieldChange({
      vehicle_model_slug: newValue?.slug,
      page: 1,
    }),
  },
});
